<template>
    <div>
        <div class="modal fade hidden-print" data-name="take" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" style="width: 100%; padding-left: 15px; max-width: 1550px;">
                <div class="modal-content" style="width: 100%;">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"  @click="reset()"><span
                                aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">
                            {{trans('warehouseman.take.title')}}
                        </h4>
                    </div>
                    <div v-show="loading==0">
                        <div class="modal-body compact-errors">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="row">
                                        <dc-core-single-select
                                                v-if="allowChooseSupplier"
                                                v-model="form.data.supplier"
                                                :checked="form.data.supplier"
                                                :options="suppliers"
                                                :show-labels="false"
                                                :custom-label="translateListObj"
                                                :errors="form.options.errors"
                                                name="supplierId"
                                                :title="trans('warehouseman.take.search.from_supplier')"
                                                @dispatch="changeSupplierEvent({$event})"
                                        >
                                        </dc-core-single-select>
                                    </div>
                                    <div v-if="!allowChooseSupplier" class="form-group row">
                                        <div class="col-md-3 control-label">
                                            {{ trans('warehouseman.take.search.from_supplier') }}
                                        </div>
                                        <div class="col-md-9">
                                            <span>{{ form.supplierName }}</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <dc-core-single-select
                                                v-model="form.data.warehouseTo"
                                                :checked="form.data.warehouseTo"
                                                :options="form.options.supplyWarehouses"
                                                :errors="form.options.errors"
                                                name="warehouseToId"
                                                :show-labels="false"
                                                :custom-label="translateListObj"
                                                :title="trans('warehouseman.take.search.warehouse_to')"
                                        >
                                        </dc-core-single-select>
                                    </div>
                                    <div class="row">
                                        <dc-core-single-select
                                                v-model="form.data.receiver"
                                                :checked="currentUser"
                                                :options="users"
                                                :errors="form.options.errors"
                                                :show-labels="false"
                                                :custom-label="translateUserListObj"
                                                name="receiverId"
                                                :title="trans('warehouseman.take.search.receiver')"
                                        >
                                        </dc-core-single-select>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-md-3 control-label">
                                            {{ trans('warehouseman.take.search.sum_value') }}
                                        </div>
                                        <div class="col-md-9">
                                            {{ form.sumValue }}
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-md-3 control-label">
                                            {{ trans('warehouseman.take.table.material_release_receipt') }}
                                        </div>
                                        <div class="col-md-4">
                                            <input v-model="bulkMaterialReleaseReceipt" type="text" class="form-control">
                                        </div>
                                        <div class="col-md-3">
                                            <div class="btn btn-primary" @click="massUpdateMaterialReleaseReceipt">
                                                {{trans('warehouseman.button.put_in_all_positions')}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table class="table table-condensed" style="margin-bottom: 0;">
                                <thead>
                                <tr>
                                    <th>{{ trans('warehouseman.take.table.object_type') }}</th>
                                    <th style="width: 270px;">{{ trans('warehouseman.take.table.position') }}</th>
                                    <th>{{ trans('warehouseman.take.table.purchase_order') }}</th>
                                    <th>{{ trans('warehouseman.take.table.unit') }}</th>
                                    <th>{{ trans('warehouseman.take.table.expected') }}</th>
                                    <th>{{ trans('warehouseman.take.table.taken') }}</th>
                                    <th style="width: 110px; text-align: center">{{ trans('warehouseman.take.table.take') }}</th>
                                    <th style="width: 135px;">{{ trans('warehouseman.take.table.final_unit_price') }}</th>
                                    <th>{{ trans('warehouseman.take.table.weight') }}</th>
                                    <th>{{ trans('warehouseman.take.table.value') }}</th>
                                    <th style="width: 140px; text-align: center">
                                        {{ trans('warehouseman.take.table.material_release_receipt') }}
                                    </th>
                                    <th>{{ trans('warehouseman.take.table.description') }}</th>
                                    <th style="width: 50px;"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(shift, i) in form.data.shifts" :key="i">
                                    <td>{{ translateObjectType(shift.item.objectType) }}</td>
                                    <td>
                                        <span v-if="shift.item.id">{{ shift.objectName }}</span>
                                        <singleselect
                                                v-if="!shift.item.id && form.data.supplier"
                                                ref="sss"
                                                v-model="shift.object"
                                                :options="form.options.products"
                                                :show-labels="false"
                                                :custom-label="translateListObj"
                                                :allow-empty="false"
                                                @dispatch="getUnitForProduct({$event}, i)"
                                        >
                                        </singleselect>
                                        <span v-if="!shift.item.id && !form.data.supplier">
                                        <i>{{ trans('warehouseman.take.shoose_supplier') }}</i>
                                    </span>
                                    </td>
                                    <td>{{ shift.purchaseOrderNum }}</td>
                                    <td>{{ translateUnit(shift.item.unit) }}</td>
                                    <td>{{ shift.item.amountExpected }}</td>
                                    <td>{{ shift.item.amountFinal }}</td>
                                    <td style="width: 110px">
                                        <input
                                                v-model="shift.amountToTake"
                                                type="number"
                                                class="form-control"
                                                min="0"
                                                @change="updateAmountToTake(shift)"
                                        >
                                    </td>
                                    <td>
                                        <input
                                                v-model="shift.unitPrice"
                                                type="number"
                                                class="form-control"
                                                min="0"
                                                @change="updateUnitPrice(shift)"
                                        >
                                    </td>
                                    <td>{{ shift.amountToTake ? dcNumberFormat(shift.item.unitWeight * shift.amountToTake) : 0 }}</td>
                                    <td>{{ shift.value }}</td>
                                    <td style="width: 140px">
                                        <input
                                          v-model="shift.materialReleaseReceipt"
                                          type="text"
                                          class="form-control"
                                        >
                                    </td>
                                    <td>
                                        <textarea
                                                v-model="shift.description"
                                                rows="1"
                                                class="form-control"
                                        />
                                    </td>
                                    <td>
                                        <button
                                                v-if="!shift.item.id"
                                                class="btn btn-danger btn-sm"
                                                :disabled="form.data.shifts.length<=1"
                                                @click="remove(i)"
                                        ><span class="fa fa-minus"></span></button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div v-if="form.options.errors.shifts" class="has-error">
                                <span class="help-block"><p>{{trans('warehouseman.common.table.fill_all_fields')}}</p></span>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <button
                                            class="btn btn-primary"
                                            :disabled="allowChooseSupplier && !form.data.supplier"
                                            @click="add()"
                                    >
                                        <i class="fa fa-plus"></i>
                                        {{trans('warehouseman.common.table.add_position')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="print()">
                                <i class="fa fa-print"></i>
                                {{trans('warehouseman.common.print')}}
                            </button>
                            <button type="button" class="btn btn-success spinner" :data-loading-text="loadingText" @click="execute()">
                                <i class="fa fa-arrow-down"></i>
                                {{trans('warehouseman.take.execute')}}
                            </button>
                            <button
                                    v-if="!allowChooseSupplier"
                                    type="button"
                                    class="btn btn-success spinner"
                                    :data-loading-text="loadingText"
                                    @click="execute(true)"
                            >
                                <i class="fa fa-cart-arrow-down"></i>
                                {{trans('warehouseman.take.execute_and_close')}}
                            </button>
                            <button type="button" class="btn btn-default" data-dismiss="modal" @click="reset(true)">
                                {{trans('warehouseman.common.close')}}
                            </button>
                        </div>
                    </div>
                    <div v-show="loading > 0" class="modal-body">
                        <span>
                            <h2>{{ trans('form.please_wait') }}...</h2>
                            <ring-loader></ring-loader>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div id="print_take" class="print-block hide" data-name="take">
            <table class="table" style="width: 50%;">
                <tr>
                    <th>{{ trans('warehouseman.take.search.from_supplier')}}</th>
                    <td>
                        <span v-if="allowChooseSupplier">
                            {{ form.data.supplier ? form.data.supplier.name : '-' }}
                        </span>
                        <span v-else>
                            {{ form.supplierName }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{ trans('warehouseman.take.search.to_warehouse')}}</th>
                    <td>
                        {{ warehouseToName }}
                    </td>
                </tr>
                <tr>
                    <th>{{ trans('warehouseman.take.search.receiver')}}</th>
                    <td>{{ form.data.receiver ? form.data.receiver.username : '-' }}</td>
                </tr>
                <tr>
                    <th>{{ trans('warehouseman.take.search.sum_value') }}</th>
                    <td>{{ form.sumValue }}</td>
                </tr>
            </table>
            <table class="table" style="margin-top: 30px; ">
                <thead>
                <tr>
                    <th>{{ trans('warehouseman.take.table.object_type') }}</th>
                    <th>{{ trans('warehouseman.take.table.position') }}</th>
                    <th>{{ trans('warehouseman.take.table.purchase_order') }}</th>
                    <th>{{ trans('warehouseman.take.table.unit') }}</th>
                    <th>{{ trans('warehouseman.take.table.expected') }}</th>
                    <th>{{ trans('warehouseman.take.table.taken') }}</th>
                    <th>{{ trans('warehouseman.take.table.take') }}</th>
                    <th>{{ trans('warehouseman.take.table.final_unit_price') }}</th>
                    <th>{{ trans('warehouseman.take.table.value') }}</th>
                    <th>{{ trans('warehouseman.take.table.description') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(shift, i) in form.data.shifts" :key="i">
                    <td>{{ shift.item.objectType ? translateObjectType(shift.item.objectType) : '-' }}</td>
                    <td>
                        <span v-if="shift.item.id">{{ shift.objectName }}</span>
                        <span v-else>{{ shift.object ? shift.object.name : '-' }}</span>
                    </td>
                    <td>{{ shift.purchaseOrderNum }}</td>
                    <td>{{ translateUnit(shift.item.unit) }}</td>
                    <td>{{ shift.item.amountExpected }}</td>
                    <td>{{ shift.item.amountFinal }}</td>
                    <td>{{ shift.amountToTake }}</td>
                    <td>{{ shift.unitPrice }}</td>
                    <td>{{ shift.value }}</td>
                    <td>{{ shift.description }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Singleselect from '../../component/simple-form/singleselect.vue'
import DcCoreSingleSelect from '../../component/dccore-form/singleselect.vue'
import * as toastr from 'toastr'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import store from '../../store/warehouseman'
import warehousemanMixins from '../mixins/warehouseman-mixins'
import mixins from '../mixins'

export default {
  store,
  components: {
    Singleselect,
    DcCoreSingleSelect,
    RingLoader,
  },
  mixins: [warehousemanMixins, mixins],
  props: {},
  data: function () {
    return {
      bulkMaterialReleaseReceipt: null,
      items: [],
      allowChooseSupplier: null,
      loading: 0,
      loadingText : `<i class='fa fa-spinner fa-spin '></i>${Translator.trans('form.please_wait')}`,
      form: {
        data: this.defaultData(),
        options: {
          products: [],
          supplyWarehouses: [],
          errors: {},
        },
        currentUser: null,

        supplierName: null,
        sumValue: 0,
      },
      //allowedStatuses: [],
      events: {
        done: function () {
        },
      },
    }
  },
  computed: {
    users() {
      return this.$store.state.users
    },
    allowedTakeStatuses() {
      return this.$store.state.allowedTakeStatuses
    },
    currentUser() {
      return this.$store.state.currentUser
    },
    allowedTakeTypes() {
      return this.$store.state.allowedTakeTypes
    },
    suppliers() {
      return this.$store.state.suppliers
    },
    warehouseToName() {
      return this.form.data.shifts.length > 0 && 'warehouseTo' in this.form.data.shifts[0].item ?
        this.form.data.shifts[0].item.warehouseTo.name :
        Translator.trans('warehouseman.take.search.default_to_warehouse')
    }
  },
  watch: {
    'form.data.shifts': function () {
      this.form.data.shifts.forEach(shift => {
        if (shift.materialReleaseReceipt === '') {
          shift.materialReleaseReceipt = null
        }
      })
      this.form.sumValue = this.getSumValue()
    }
  },
  created() {
    $('.modal[data-name=take]').on('hidden.bs.modal', () => {
      $('.print-block[data-name=take]').removeClass('visible-print-block')
      this.events.done()
    })

  },
  methods: {
    init(items) {
      this.bulkMaterialReleaseReceipt = null
      $('#popup_take').button('loading')
      this.items = items
      this.getSupplyWarehouses()
      return Promise.all([
        this.$store.dispatch('fetchCurrentUser'),
        this.$store.dispatch('fetchUsers'),
        this.$store.dispatch('fetchAllowedTakeStatuses'),
        this.$store.dispatch('fetchAllowedTakeTypes')
      ]).then( () => {
        $('#popup_take').button('reset')
        return new Promise((resolve, reject) => {

          this.reset(false)

          items = this.prepareInput(this.items)

          if (!items) {
            reject()
            this.close()
            return
          }

          this.open()
          this.getShifts(items)
            .then(() => {
              this.events.done = () => {
                resolve()
              }
            })
            .catch(() => {
              this.close()
              reject()
            })
        })
      }
      )
    },
    prepareInput(items) {
      let countBeforeFilter = items.length

      items = items.filter(item => {
        return this.allowedTakeStatuses.includes(item.status)
                        && this.allowedTakeTypes.includes(item.moveType)
      })

      if (items.length < countBeforeFilter) {
        toastr.error(Translator.trans('warehouseman.common.selected_invalid_shifts'))
        return
      }

      return items.map(item => {
        return item.id
      })
    },
    open() {
      $('.modal[data-name=take]').modal({
        backdrop: 'static',
        keyboard: false
      })
      $('.print-block[data-name=take]').addClass('visible-print-block')
    },
    close() {
      $('.modal[data-name=take]').modal('hide')
      $('.print-block[data-name=take]').removeClass('visible-print-block')
    },
    print() {
      this.printElement('print_take')
    },
    remove(i) {
      this.form.data.shifts.splice(i, 1)
      this.refresh()

      setTimeout(() => {
        this.$refs.sss.forEach(ref => {
          ref.value = ref.$attrs.value
        })
      }, 1)
    },
    add() {
      this.form.data.shifts.push(this.create())
    },
    defaultData() {
      return {
        warehouseToId: null,
        supplierId: null,
        receiverId: this.form && this.currentUser ? this.currentUser.id : null,
        supplier: null,
        warehouseTo: null,
        receiver: this.form ? this.currentUser : null,
        shifts: [],
        closeTaking : false,
      }
    },
    updateAmountToTake(shift) {
      this.updateValue(shift)
    },
    updateUnitPrice(shift) {
      shift.unitPrice = parseFloat(shift.unitPrice).toFixed(2)
      this.updateValue(shift)
    },
    updateValue(shift) {
      shift.value = this.getValue(shift.amountToTake, shift.unitPrice)
      this.form.sumValue = this.getSumValue()
    },
    roundNumber(value) {
      return Math.round(value * 1000) / 1000
    },
    getValue(amountToTake, unitPrice) {
      let formatter = new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })

      let value = amountToTake && unitPrice ? this.roundNumber(amountToTake * unitPrice) : 0
      return formatter.format(this.roundNumber(value))
    },
    getSumValue() {
      let sum = 0
      this.form.data.shifts.forEach(shift => {
        sum += this.fromFormatToFloat(shift.value) || 0
      })

      let formatter = new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })

      return formatter.format(this.roundNumber(sum))
    },
    fromFormatToFloat(format) {
      return parseFloat(format.replace(',', '.').replace(/\s/g, ''))
    },
    create() {
      return {
        item: {
          objectType: 'product',
          amountExpected: '-',
          amountFinal: '-',
        },
        value: this.getValue(0, 0),
        purchaseOrderNum: '-',
      }
    },
    execute(closeTaking = false) {
      $('.spinner').button('loading')
      this.form.data.closeTaking = closeTaking
      this.prepareDataToSend()
      this.$http.patch(
        Routing.generate('api_warehouseman_patch_take'), this.form.data).then(
        () => {
          this.close()
          this.reset()
          this.events.done()
          $('.spinner').button('reset')
        },
        response => {
          this.handleAjaxError(response, this.form.options)
          $('.spinner').button('reset')
        }
      )
    },
    prepareDataToSend() {
      if (this.form.data.supplier) {
        this.form.data.supplierId = this.form.data.supplier.id
      }

      if (this.form.data.receiver) {
        this.form.data.receiverId = this.form.data.receiver.id
      }

      if (this.form.data.warehouseTo) {
        this.form.data.warehouseToId = this.form.data.warehouseTo.id
      }

      this.form.data.shifts.forEach((shift, i) => {
        if (shift.object) {
          this.form.data.shifts[i].objectId = shift.object.id
        }
      })
    },
    changeSupplierEvent(event) {
      this.getProducts(event.$event.id)
      this.resetShifts()
    },
    /**
             * Reset shifts to default state
             * Delete add added shifts and delete existed by default
             */
    resetShifts() {
      this.form.data.shifts = []
      this.add()
    },
    getProducts(supplierId) {
      this.loading++
      this.$http.get(Routing.generate('api_get_products_buyable_by_supplier', {
        id: supplierId,
        context: 'product_basic'
      })).then(response => {
        this.form.options.products = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    getShifts(shiftsIds) {
      return new Promise((resolve, reject) => {
        let takenShifts = []
        this.form.data.shifts = []
        if (shiftsIds.length) {
          this.allowChooseSupplier = false
          shiftsIds.forEach(itemId => {
            this.loading++
            Vue.http.get(
              Routing.generate('api_warehouseman_get_take', {
                warehouseShift: itemId,
              })
            ).then(response => {
              takenShifts.push(this.prepareItem(response.data))
              this.loading--

              if (takenShifts.length === shiftsIds.length) {
                if (!this.checkShifts(takenShifts)) {
                  toastr.error(Translator.trans('warehouseman.common.selected_invalid_shifts'))
                  reject()
                  return
                }

                this.setSupplier(response.data.supplierId)

                this.form.data.warehouseTo = this.form.options.supplyWarehouses.filter(
                  warehouse => warehouse.id === response.data.warehouseToId
                )[0]
                this.form.data.warehouseToId = this.form.data.warehouseTo.id

                this.form.data.shifts = this.sortByObjectName(takenShifts)
                resolve()
              }
            }, response => {
              this.handleAjaxError(response)
            })
          })
        } else {
          this.allowChooseSupplier = true
          this.form.data.warehouseTo = this.form.options.supplyWarehouses[0]
          this.form.data.warehouseToId = this.form.data.warehouseTo.id
          this.$store.dispatch('fetchSuppliers').then(() => {
            this.add()
            resolve()
          })
        }
      })
    },
    massUpdateMaterialReleaseReceipt() {
      this.form.data.shifts.forEach(shift => {
        shift.materialReleaseReceipt = this.bulkMaterialReleaseReceipt
      })
      this.refresh()
    },
    checkShifts(shifts) {
      let BreakException = {}
      let from = null
      let to = null

      // check if each shif has supplierId
      try {
        shifts.forEach(shift => {
          if (!shift.supplierId) {
            throw BreakException
          }

          if (from === null) {
            from = shift.supplierId
          } else {
            if (shift.supplierId !== from) {
              throw BreakException
            }
          }

          if (to === null) {
            to = shift.item.warehouseTo
          } else {
            if (shift.item.warehouseTo.id !== to.id) {
              throw BreakException
            }
          }
        })
      } catch (e) {
        if (e === BreakException) {
          return false
        }
      }

      return true
    },
    prepareItem(item) {
      item.amountToTake = item.item.amountExpected - (item.item.amountFinal ? item.item.amountFinal : 0)
      item.shiftId = item.item.id
      item.unitPrice = item.priceNettoFinal
      item.value = this.getValue(0, 0)
      return item
    },
    setSupplier(supplierId) {
      this.loading++
      Vue.http.get(Routing.generate('api_get_supplier', {
        id: supplierId,
        context: 'dropdown'
      })).then(response => {
        this.form.data.supplier = response.data
        this.form.data.supplierId = response.data.id
        this.form.supplierName = response.data.name
        this.loading--
        this.getProducts(response.data.id)
      }, response => {
        this.loading--
        this.handleAjaxError(response)
      })
    },

    getUnitForProduct(event, shiftIndex) {
      this.form.data.shifts[shiftIndex].item.unit = event.$event.unit
      this.form.data.shifts[shiftIndex].item.unitWeight = event.$event.unitWeight
    },
    getSupplyWarehouses: function () {
      this.loading++
      let url = Routing.generate('api_get_warehouse_supply_warehouses')

      Vue.http.get(url).then(response => {
        this.form.options.supplyWarehouses = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    sortByObjectName(shifts) {
      return shifts.sort((a, b) => {
        let name1 = a.objectName.toLowerCase()
        let name2 = b.objectName.toLowerCase()

        let comparison = 0
        if (name1 > name2) {
          comparison = 1
        } else if (name1 < name2) {
          comparison = -1
        }
        return comparison
      })
    }
  },
}
</script>

<style>
.table-print {
    border: 1px solid black;
}
</style>
